import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { TableLightColumnComponent } from "../../table-light/table-light-column/table-light-column.component";

@Component({
    standalone: false,
    templateUrl: "./table-light.component.html",
    styleUrls: ["./table-light.component.css"],
})
export class FormTableLightComponent extends FieldType<FieldTypeConfig> {
    ngOnInit() {
        this.model[this.key as string] = this.model[this.key as string] || [];
    }

    onRowChanged(event) {
        if (this.props.change) this.props.change(this.field, event);
    }

    onColumnChanged(event, column: TableLightColumnComponent) {
        if (column.change) column.change(event);
    }
}
